import { useEffect } from "react";
import { Nav } from "../components/site/Nav";
import { Hero } from "../components/site/Hero";
import { HeroBlobs } from "../components/site/HeroBlobs";
import { TickerWords } from "../components/site/TickerWords";
import { About } from "../components/site/About";
import { LoopEngine } from "../components/site/LoopEngine";
import { WhoItsFor } from "../components/site/WhoItsFor";
import { ClosedLoops } from "../components/site/ClosedLoops";
import { Ticker2 } from "../components/site/Ticker2";
import { GetLoopedIn } from "../components/site/GetLoopedIn";
import { Footer } from "../components/site/Footer";

export default function Landing() {
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash;
      const t = setTimeout(() => {
        const el = document.querySelector(id);
        if (el) {
          if (window.__lenis) window.__lenis.scrollTo(el, { offset: -10 });
          else el.scrollIntoView();
        }
      }, 400);
      return () => clearTimeout(t);
    }
  }, []);

  return (
    <div className="grain relative">
      <HeroBlobs />
      <Nav />
      <main>
        <Hero />
        <TickerWords />
        <About />
        <LoopEngine />
        <WhoItsFor />
        <ClosedLoops />
        <Ticker2 />
        <GetLoopedIn />
      </main>
      <Footer />
    </div>
  );
}
